import { useContext } from 'react'
import { AuthContext } from 'context/authContext'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { logoutUser } from 'utils/api/auth'
import { PAGE_LOGIN } from 'utils/constants'

const useAuth = () => {
  const context = useContext(AuthContext)

  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider')
  }

  const navigate = useNavigate()

  const logout = async () => {
    const loader = toast.loading('Logging out...')
    try {
      await logoutUser()
      navigate(PAGE_LOGIN.path)
      toast.success('Logout Successful', { id: loader })
    } catch (error) {
      toast.error('Unable to logout', { id: loader })
    }
  }

  return { ...context, logout }
}

export default useAuth
